// Initialize each native homepage video once, including dynamic review cards.
// Later mute/unmute choices belong to the visitor and are never reset.
(() => {
  const initialized = new WeakSet();
  function initialize(root) {
    const videos = root.matches?.('video') ? [root] : root.querySelectorAll?.('video') || [];
    for (const video of videos) {
      if (initialized.has(video)) continue;
      initialized.add(video);
      video.defaultMuted = true;
      video.muted = true;
    }
  }
  initialize(document);
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) initialize(node);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
